<template>
  <!-- pop-delete-block -->
  <div class="popup_in">
    <div class="popup pop-delete-block">
      <div class="popup_close">
        <a @click="$emit('close')"><CloseSvg /></a>
      </div>
      <div class="title bold">
        לתשומת ליבך
      </div>
      <div class="text let-1">
        לאחר אישורך, יומן המרפאה יפתח
        <br />
        לקביעת תורים באמצעות מוקד זימון התורים וזימון דיגיטלי
      </div>
      <a
        class="bt_blue bt-approveDelete w-100"
        @click="confirmActivate"
        href="javascript:void(0)"
        >אישור</a
      >
    </div>
  </div>
  <!-- End pop-delete-block -->
</template>

<script>
import CloseSvg from "@/assets/img/svg/close-sm.svg";
import BlockDisabled from "@/components/Popups/BlockDisabled";
import Error from "@/components/Popups/Error";

export default {
  name: "ConfirmActivateBlock",
  props: ["block_id"],
  data() {
    return {
      app_info: "",
      block_info: ""
    };
  },
  mounted() {
    this.$API
      .getBlockInfo(this.block_id)
      .then(res => {
        this.block_info = res;
      })
      .catch(e => {
        this.$modal.show(Error);
      });
  },
  methods: {
    close() {
      this.$emit("close");
      this.$router.push({ name: "Dashboard" });
    },
    confirmActivate() {
      this.$emit("close");
      this.$API
        .change_block_status([this.block_id], "approved")
        .then(res => {
          this.$modal.show(BlockDisabled, {
            block: this.block_info,
            title: "בלוק המרפאה התעדכן לסטטוס פעיל"
          });
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    }
  },
  computed: {},
  components: { CloseSvg }
};
</script>

<style scoped></style>
